import { PAGE_TYPE_CATEGORY } from 'shared/consts'
import {
  CAT_MORE_PRODUCTS_ON_FIRST_CSW,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { trackCswSlider } from 'shared/experiments/consts/trackCswSlider'
import {
  activateExperiment,
  getExperiment,
} from 'shared/experiments/utils/experiments'
import store from 'shared/store'

export default () => {
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { experiments = [], pageType = '' } =
    publicRuntimeConfig?.pageProperties || {}
  const { variant, isEnabled } = getExperiment(
    CAT_MORE_PRODUCTS_ON_FIRST_CSW,
    experiments
  )
  if (pageType !== PAGE_TYPE_CATEGORY || !isEnabled) {
    return
  }
  void activateExperiment(CAT_MORE_PRODUCTS_ON_FIRST_CSW)
  if (variant === EXPERIMENT_VARIATION.V1) {
    trackCswSlider({
      shouldTrackShowMoreClick: true,
    })
  }
}
